import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import { action } from '@ember/object';
import IntegrationsPublicController from './controller';
import WindowMessengerService from 'cio/services/window-messenger';
import Transition from '@ember/routing/-private/transition';
import ApiErrorsService from 'cio/services/api-errors';

export default class IntegrationsPublic extends Route {
  @service router!: RouterService;
  @service windowMessenger!: WindowMessengerService;
  @service apiErrors!: ApiErrorsService;

  async setupController(controller: IntegrationsPublicController, model: Record<string, any>, transition: Transition) {
    super.setupController(controller, model, transition);

    try {
      await controller.fetchIntegrations.perform();
    } catch (e) {
      this.apiErrors.report(e);
    }

    window.addEventListener('resize', controller.handleResize);
    this.windowMessenger.on('popstate', this.handlePopstate);
  }

  resetController(controller: IntegrationsPublicController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      window.removeEventListener('resize', controller.handleResize);
    }
  }

  handlePopstate() {
    window.history.back();
  }

  @action
  willTransition(transition: any) {
    if (transition.to.name === 'integrations-public.type') {
      this.windowMessenger.send('page-change', {
        path: `/integrations/${transition.to.params.type}`,
      });
    }
  }
}
